import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize, map} from 'rxjs/operators';

import {IsEmptyString, IsEmptyVar} from '../../defines/common.func';
import {PAGE, WORD_HOMONYM_API_URL} from '../../defines/protocol';
import {SearchParam} from '../../defines/client.const';
import {Homonym} from '../../models/homonym.model';
import {ListLoader, ListLoader_NextList} from '../../interfaces/list-loader';
import {ApiService} from '../api/api.service';
import {NormalizeSearchKeyword} from '../../defines/search-keyword.func';


/**
 * 문제점: 현재 받아오는 목록에서 동음이의어의 총 갯수를 알 수 없다.
 *
 */
@Injectable({
  providedIn: 'root'
})
export class HomonymService implements ListLoader<Homonym> {
  protected urlApi = WORD_HOMONYM_API_URL;

  protected totalCount: number;
  private listHomonym: Array<Homonym> = null;
  private mapHomonym: Map<string, Homonym> = null;
  private nextUrl: string;
  private load$: Observable<ListLoader_NextList<Homonym>> = null;
  private loadDetail$: Observable<Homonym> = null;

  constructor(
    private api: ApiService,
  ) { }

  /******************************************************************************
   * ListLoader<Homonym> 구현부
   *****************************************************************************/
  public getList(): Array<Homonym> {
    return this.listHomonym;
  }
  public getCurCount(): number {
    return IsEmptyVar(this.listHomonym) ? null : this.listHomonym.length;
  }
  public getTotalCount(): number {
    return IsEmptyVar(this.totalCount) ? null : this.totalCount;
  }
  public IsComplete(): boolean {
    return this.totalCount === 0 ||
      (!IsEmptyVar(this.listHomonym) && !IsEmptyVar(this.totalCount) && this.listHomonym.length === this.totalCount);
  }
  public IsLoading(): boolean {
    return this.load$ !== null;
  }
  public getById(id: string): Homonym {
    return this.mapHomonym.get(id) ?? null;
  }

  public ResetList(param: SearchParam = null): void {
    this.nextUrl = null;
    this.listHomonym = null;
    this.mapHomonym = null;
    this.totalCount = null;

    if (param) {
      if ('index' in param) {
        this.nextUrl = this.urlApi + '?index=' + param.index;
      }
      else if ('keyword' in param) {
        const keyword = NormalizeSearchKeyword(param.keyword);
        if (!IsEmptyString(keyword)) {
          this.nextUrl = this.urlApi + '?search=' + keyword;
        }
      }

      if ('level' in param) {
        this.nextUrl = this.nextUrl ?
          this.nextUrl + '&level=' + param.level :
          this.urlApi + '?level=' + param.level;
      }

      if ('start' in param) {
        this.nextUrl = this.nextUrl ? this.nextUrl + '&start=' + param.start : this.urlApi + '?start=' + param.start;
      }
    }

    if (!this.nextUrl) {
      this.nextUrl = this.urlApi;
    }

    console.log('HomonymService::ResetList()', param, this);
  }

  public GetNextList(): Observable<ListLoader_NextList<Homonym>> {
    console.log('HomonymService::GetNextList()');

    if (IsEmptyString(this.nextUrl)) {
      return throwError({error: 'No more pages in HomonymList'});
    }

    if (this.load$) {
      return this.load$;
    }

    return this.load$ = this.api.Get(this.nextUrl).pipe(
      catchError(err => {
        if ('status' in err && err.status === 404) {
          this.totalCount = 0;
        }
        throw err;
      }),
      finalize(() => {
        this.load$ = null;
      }),
      map((data: PAGE) => {
        console.log('getWordList.api.Get data =', data);

        let first = false;
        if (this.totalCount === null) {
          this.totalCount = data.count;
          this.listHomonym = new Array<Homonym>();
          this.mapHomonym = new Map<string, Homonym>();
          first = true;
        }
        else if (this.totalCount !== data.count) {
          console.error('[error]' + this.urlApi, data );
        }

        const list = new Array<Homonym>();

        data.results.forEach(value => {
          const homonym = new Homonym(value);
          list.push(homonym);
          this.listHomonym.push(homonym);
          this.mapHomonym.set(homonym.name, homonym);
        });

        this.nextUrl = data.next;

        return {list, first};
      })
    );
  }


  /******************************************************************************
   * 상세 이운이의어 정보 획득
   * 위쪽의 목록에는 간섭이 없도록 처리하는 것이 좋다.
   * TODO: 로딩중인 것을 처리. (예외상황 처리 추가해야 함)
   *****************************************************************************/
  public GetDetail(homonym: string): Observable<Homonym> {
    const url = this.urlApi + homonym + '/';
    console.log('HomonymService::GetDetail() url =', url);

    return this.loadDetail$ = this.api.Get(url).pipe(
      finalize(() => this.loadDetail$ = null),
      map(value => {
        const out = new Homonym(value);
        console.log('HomonymService::GetDetail data = ', value, out);
        return out;
      })
    );
  }
}
